export const double_bonus_chance_widget = (t) => ({
	DOUBLE_CHANCE_SWITCHER_ON: {
		value: 'ON',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	DOUBLE_CHANCE_SWITCHER_OFF: {
		value: 'OFF',
		config: {
			fill: '#CBCAEA',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18
		}
	},
	DOUBLE_CHANCE_VALUE: {
		value: '10.00',
		config: {
			fill: ['#9b61e4', '#6c25b4'],
			fontFamily: 'Poppins Bold',
			fontSize: 42
		}
	},
	DOUBLE_CHANCE_CURRENCY: {
		value: 'BYN',
		config: {
			fill: ['#9b61e4', '#6c25b4'],
			fontFamily: 'Poppins Bold',
			fontSize: 22
		}
	},
	DOUBLE_CHANCE_TITLE: {
		value: t('common.ui_double_chance_title'),
		config: {
			fill: '#bab5db',
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			lineHeight: 22,
			wordWrap: true,
			wordWrapWidth: 170
		}
	},
	DOUBLE_CHANCE_SUBTITLE: {
		value: t('common.feature'),
		config: {
			fill: ['#7eba21', '#447e15'],
			fontFamily: 'Poppins SemiBold',
			fontSize: 18,
			lineHeight: 42
		}
	}
});
